var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"sign-in-button",attrs:{"href":"/api/auth/steam"},on:{"click":function($event){return _vm.storeCurrentRoute()}}},[_c('img',{staticClass:"steam-icon mr-1",attrs:{"src":"/images/site/steam_icon.png","alt":"Steam Login Button"}}),_vm._v(" Sign In ")])
}
var staticRenderFns = []

export { render, staticRenderFns }